import { useEffect, useState } from 'react';
import { TGDDesign } from '../../../models/courses/graphicDesign';
import { FONT_STYLESHEET_URL, resolveFontFamily } from '../core/fonts';

export const useGDFonts = (design: TGDDesign): number => {
  const [fontsVersion, setFontsVersion] = useState(0);
  const fonts = [...new Set(design.components.filter(c => c.type === 'text')
    .map(c => `${c.fontWeight ?? 400} 32px ${resolveFontFamily(c)}`))].sort().join('|');
  useEffect(() => {
    if (!document.getElementById('gd-fonts')) {
      const link = document.createElement('link');
      link.id = 'gd-fonts';
      link.rel = 'stylesheet';
      link.href = FONT_STYLESHEET_URL;
      document.head.appendChild(link);
    }
    let active = true;
    Promise.allSettled(fonts.split('|').filter(Boolean).map(font =>
      document.fonts.load(font))).then(() => {
      if (active) setFontsVersion(version => version + 1);
    });
    return () => { active = false; };
  }, [fonts]);
  return fontsVersion;
};
